<template>
  <div class="base-info-container">
    <div class="title">基本信息</div>
    <div class="block">
      <el-table
        :data="baseInfoTable"
        :show-header="false"
        border
        class="colorful-table base-info"
        :cellStyle="cellStyle"
        :span-method="mergeCell"
        :highlight-current-row="false"
        size="mini"
      >
        <el-table-column :align="align" prop="key1" width="90"></el-table-column>
        <el-table-column :align="align" prop="val1" min-width="160"></el-table-column>
        <el-table-column :align="align" prop="key2" width="90"></el-table-column>
        <el-table-column :align="align" prop="val2" min-width="160"></el-table-column>
        <el-table-column :align="align" prop="key3" width="80"></el-table-column>
        <el-table-column :align="align" prop="val3" min-width="80"></el-table-column>
        <el-table-column :align="align" prop="key4" width="70"></el-table-column>
        <el-table-column :align="align" prop="val4" min-width="80"></el-table-column>
        <el-table-column :align="align" prop="key5" width="70"></el-table-column>
        <el-table-column :align="align" prop="val5" min-width="80"></el-table-column>
        <el-table-column :align="align" prop="key6" width="70"></el-table-column>
        <el-table-column :align="align" prop="val6" min-width="160"></el-table-column>
      </el-table>
    </div>
    <base-other-info :waybillSplitId="waybillSplitId"></base-other-info>
    <div class="title">发货人信息</div>
    <div class="block">
      <el-table
        style="width:100%;"
        :data="SendAddrInfo"
        :show-header="false"
        border
        class="colorful-table"
        :cellStyle="cellStyle"
        :span-method="mergeCell"
        size="mini"
      >
        <el-table-column :align="align" prop="key1" width="80"></el-table-column>
        <el-table-column :align="align" prop="val1" width="200"></el-table-column>
        <el-table-column :align="align" prop="key2" width="80"></el-table-column>
        <el-table-column :align="align" prop="val2" width="200"></el-table-column>
        <el-table-column :align="align" prop="key3" width="80"></el-table-column>
        <el-table-column :align="align" prop="val3" width="200"></el-table-column>
        <el-table-column :align="align" prop="key4" width="80"></el-table-column>
        <el-table-column :align="align" prop="val4"></el-table-column>
      </el-table>
    </div>
    <div class="title">货物信息</div>
    <div class="block">
      <el-table :data="goods" size="mini">
        <el-table-column
          :align="align"
          prop="key1"
          label="序号"
          type="index"
          width="50"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="goodsNumber"
          label="获取编号"
          width="150"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="goodsName"
          label="品名"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="packageName"
          label="包装"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="packageCout"
          label="件数"
          width="100"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="grossWeight"
          label="毛重"
          width="100"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="netWeight"
          label="净重"
          width="100"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="volume"
          label="体积"
          width="100"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="volumeWeight"
          label="体积重量"
          width="100"
        ></el-table-column>
        <el-table-column
          :align="align"
          prop="billingWeight"
          label="计费重量"
          width="100"
        ></el-table-column>
        <el-table-column :align="align" prop="val3" label="规格" width="100">
          <template #default="{ row }">
            <el-button type="text" @click="viewItemSpes(row)">
              {{
                row.itemSpecss && row.itemSpecss[0]
                  ? `${row.itemSpecss[0].wide} * ${row.itemSpecss[0].length} * ${row.itemSpecss[0].height}`
                  : ""
              }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :align="align"
          prop="heavyCargo"
          label="重/泡货"
          width="150"
        ></el-table-column>
      </el-table>
    </div>
    <div class="title">收货人信息</div>
    <div class="block">
      <el-table
        style="width:100%;"
        :data="ReceAddrInfo"
        :show-header="false"
        border
        class="colorful-table"
        :cellStyle="cellStyle"
        :span-method="mergeCell"
        size="mini"
      >
        <el-table-column :align="align" prop="key1" width="80"></el-table-column>
        <el-table-column :align="align" prop="val1" width="200"></el-table-column>
        <el-table-column :align="align" prop="key2" width="80"></el-table-column>
        <el-table-column :align="align" prop="val2" width="200"></el-table-column>
        <el-table-column :align="align" prop="key3" width="80"></el-table-column>
        <el-table-column :align="align" prop="val3" width="200"></el-table-column>
        <el-table-column :align="align" prop="key4" width="80"></el-table-column>
        <el-table-column :align="align" prop="val4"></el-table-column>
      </el-table>
    </div>
    <my-image-view :show.sync="showViewer" :url-list="previewSrcList" />
    <my-dialog
      diaWidth="400px"
      dialogTitle="查看规格"
      :isShowDialog="showItemSpecs"
      @handleCloseDia="showItemSpecs = false"
      @diaCancelBtn="showItemSpecs = false"
      @diaConfirmBtn="showItemSpecs = false"
    >
      <div class="glo_dialogForm">
        <el-table :data="currentGoods.itemSpecss" border style="width: 100%">
          <el-table-column label="*长" prop="length"> </el-table-column>
          <el-table-column label="*宽" prop="wide"> </el-table-column>
          <el-table-column label="*高" prop="height"> </el-table-column>
          <el-table-column label="*件数" prop="packageCout"> </el-table-column>
        </el-table>
      </div>
    </my-dialog>
  </div>
</template>

<script>
import MyImageView from "@/components/MyImageView.vue";
import MyDialog from "@/components/Dialog.vue";
import BaseOtherInfo from './BaseOtherInfo.vue'
export default {
  components: {
    MyImageView,
    MyDialog,
    BaseOtherInfo
  },
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      align: "left",
      baseInfo: {},
      goods: [],
      financeInInfo: {},
      financeOutInfos: [],
      files: [],
      sendAddr: {},
      receiveAddr: {},
      otherInfo: {},
      transportInfo: {},
      showViewer: false,
      previewSrcList: [],
      showItemSpecs: false,
      currentGoods: {
        itemSpecss: [
          {
            wide: 0,
            length: 0,
            height: 0,
          },
        ],
      },
    };
  },
  computed: {
    baseInfoTable() {
      const baseInfo = this.baseInfo;
      const transportInfo = this.transportInfo;
      const otherInfo = this.otherInfo;
      const sendAddr = this.sendAddr;
      const receiveAddr = this.receiveAddr
      const goods = this.goods[0] || {}
      return [
        {
          key1: "运单号",
          val1: baseInfo.waybillNumber,
          key2: "货物状态",
          val2: baseInfo.goodsStatus,
          key3: '客户名称',
          val3: baseInfo.customerName,
          mergeCell:[4,3],
          key4: "业务日期",
          val4: baseInfo.businessDate,
          key5: "创建时间",
          val5: baseInfo.createTime,
        }, 
        {
          key1: "发货单位",
          val1: sendAddr.company,
          key2: "发货人",
          val2: sendAddr.contacts,
          key3: '联系电话',
          val3: sendAddr.phone,
          key4: "地址",
          val4: sendAddr.provinceName + sendAddr.cityName +sendAddr.areaName + sendAddr.address,
          key5: "回单要求",
          val5: baseInfo.rnRequireName,
          key6: "份数",
          val6: baseInfo.rnRequireCount,
        },
        {
          key1: "收货单位",
          val1: receiveAddr.company,
          key2: "收货人",
          val2: receiveAddr.contacts,
          key3: '联系电话',
          val3: receiveAddr.phone,
          key4: "地址",
          val4: receiveAddr.provinceName + receiveAddr.cityName +receiveAddr.areaName +receiveAddr.address,
          key5: "发货方式",
          val5: baseInfo.receiveMethod,
          key6: "交接方式",
          val6: baseInfo.sendMethod,
        },
        {
          key1: "品名",
          val1: goods.goodsName,
          key2: "包装",
          val2: goods.packageName,
          key3: '件数',
          val3: goods.packageCout,
          key4: "重量",
          val4: goods.grossWeight,
          key5: "体积",
          val5: goods.volume,
          key6: "计费重量",
          val6: goods.billingWeight,
        },
        {
          key1: "预计提货时间",
          val1: transportInfo.takeTime,
          key2: "预计送货时间",
          val2: transportInfo.deliveryTime,
          key3: "业务员",
          val3: otherInfo.businessName,
          key4: "录单员",
          val4: otherInfo.createUserName,
          key5: "结算员",
          val5: otherInfo.merchandiserEmployeeName,
          mergeCell:[8]
        },
        {
          key1: "提货司机",
          val1: baseInfo.driverOneName,
          key2: "提货车牌",
          val2: baseInfo.carNum,
          key3: "签收经办人",
          val3: baseInfo.signForName,
          key4: "签收时间",
          val4: baseInfo.signForTime,
          mergeCell:[6]
        },
        {
          key1: "开单网点",
          val1: baseInfo.receiveOrderDeptName,
          key2: "终端网点",
          val2: baseInfo.endDeptName,
          key3: "等通知放货状态",
          val3: baseInfo.isWaitNoticeSendShow,
          mergeCell:[4]
        },
      ];
    },
    financeInInfoTable() {
      const financeInInfo = this.financeInInfo;
      return [
        {
          key1: "计费方式",
          val1: financeInInfo.formulaBillingWeightName,
          key2: "单价",
          val2: financeInInfo.unitPrice,
          key3: "基本运费",
          val3: financeInInfo.basicFreight,
        },
        {
          key1: "提货费",
          val1: financeInInfo.takeFee,
          key2: "送货费",
          val2: financeInInfo.sendFee,
          key3: "中转费",
          val3: financeInInfo.transferFee,
        },
        {
          key1: "代收货款",
          val1: financeInInfo.agentAmount,
          key2: "代收货款费率(‰)",
          val2: financeInInfo.agentServiceRate,
          key3: "代收货款手续费",
          val3: financeInInfo.agentServiceFee,
        },
        {
          key1: "声明价值",
          val1: financeInInfo.declaredValue,
          key2: "保险费费率（‰）",
          val2: financeInInfo.declaredValueRate,
          key3: "保险费",
          val3: financeInInfo.insuranceFee,
        },
        {
          key1: "其他费用",
          val1: financeInInfo.allOtherFee,
          key2: "服务费",
          val2: financeInInfo.serviceFee,
          key3: "运费合计",
          val3: financeInInfo.totalFreight,
        },
        {
          key1: "运单结算方式",
          val1: financeInInfo.settlementMethod,
          key2: "现付金额",
          val2: financeInInfo.senderAmount,
          key3: "到付金额",
          val3: financeInInfo.receivedAmount,
        },
        {
          key1: "月结金额",
          val1: financeInInfo.monthlyAmount,
          key2: "回单付金额",
          val2: financeInInfo.rnorderAmount,
          key3: "货款扣运费",
          val3: financeInInfo.goodsDeductedAmoun,
        },
        {
          key1: "是否开票",
          val1: financeInInfo.isInvoice,
          key2: "到付结算方式",
          val2: financeInInfo.isInvoiceShow,
          key3: "财务备注",
          val3: financeInInfo.financeRemarks,
        },
      ];
    },
    SendAddrInfo(){
      const sendAddr = this.sendAddr;
      return [
        {
          key1: "发货单位",
          val1: sendAddr.company,
          key2: "联系人",
          val2: sendAddr.contacts,
          key3: "联系电话",
          val3: sendAddr.phone,
          ignoreCells: [6],
          mergeCell:[4]
        },
        {
          key1: "省份",
          val1: sendAddr.provinceName,
          key2: "城市",
          val2: sendAddr.cityName,
          key3: "区县",
          val3: sendAddr.areaName,
          key4: "详细地址",
          val4: sendAddr.address,
        },
      ]
    },
    ReceAddrInfo(){
      const receiveAddr = this.receiveAddr;
      return [
        {
          key1: "收货单位",
          val1: receiveAddr.company,
          key2: "联系人",
          val2: receiveAddr.contacts,
          key3: "联系电话",
          val3: receiveAddr.phone,
          ignoreCells: [6],
          mergeCell:[4]
        },
        {
          key1: "省份",
          val1: receiveAddr.provinceName,
          key2: "城市",
          val2: receiveAddr.cityName,
          key3: "区县",
          val3: receiveAddr.areaName,
          key4: "详细地址",
          val4: receiveAddr.address,
        },
      ]
    },
  },
  watch: {
    waybillSplitId: {
      handler(val) {
        if (!val) {
          this.baseInfo = {};
          this.goods = [];
          this.financeInInfo = {};
        }
        this.getDetail();
      },
    },
  },
  mounted(){
    this.getDetail()
  },
  methods: {
    mergeCell({ row, column, rowIndex, columnIndex }){
      if(!row.mergeCell){
        return
      }
      const mergeCell = row.mergeCell
      if(columnIndex == mergeCell[0] + 1){
        return [1,mergeCell[1] || 99]
      }
    },
    cellStyle({ row, columnIndex }) {
      const ignoreCells = row.ignoreCells;
      if (ignoreCells && ignoreCells.includes(columnIndex)) {
        return {
          background: "none",
        };
      }
    },
    async getDetail() {
      if(!this.waybillSplitId){
        return;
      }
      const res = await this.$API.getWaybillDetail(this.waybillSplitId);
      this.baseInfo = res.baseInfo;
      if (res.sendAddrs) {
        this.goods = res.sendAddrs[0].items;
        this.sendAddr = res.sendAddrs[0] || {};
      }
      if (res.receiveAddr) {
        this.receiveAddr = res.receiveAddr || {};
      }
      this.financeInInfo = res.financeInInfo || {};
      this.financeOutInfos = res.financeOutInfos || [];
      this.files = res.files || [];
      this.otherInfo = res.otherInfo || {};
      this.transportInfo = res.transportInfo;
    },
    checkAttach(row) {
      this.previewSrcList = row.files.map((item) => item.fileUrl);
      this.showViewer = true;
    },
    viewItemSpes(goods) {
      this.currentGoods = goods;
      this.showItemSpecs = true;
    },
  },
};
</script>

<style scoped lang="less">
.base-info-container {
  padding-bottom: 10px;
  .title {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #0000ff;
    border-bottom: 1px solid #d7d7d7;
    padding-left: 10px;
  }
  .block {
    margin: 10px 0 0 0;
    .colorful-table {
      /deep/ .el-table__cell:nth-child(odd) {
        background: #f9fafc;
      }
    }
  }
  .base-info{
    /deep/ .cell{
      padding-right: 2px;
    }
  }
}
</style>